import { useState } from "react";
import "./editorialForms.css";

const categories = [
  { id: "medical", name: "Saúde/Tratamento" },
  { id: "education", name: "Educação" },
  { id: "emergency", name: "Emergência" },
  { id: "business", name: "Negócios" },
  { id: "creative", name: "Projetos Criativos" },
  { id: "community", name: "Comunidade" },
  { id: "animals", name: "Animais" },
  { id: "environment", name: "Meio Ambiente" },
  { id: "other", name: "Outro" },
];

export default function CrowdfundingForm({ data, onChange }) {
  const [rewardInput, setRewardInput] = useState({ minDonation: "", description: "", limit: "" });

  const handleAddReward = () => {
    if (rewardInput.description.trim()) {
      onChange({
        ...data,
        rewards: [
          ...(data?.rewards || []),
          {
            minDonation: parseFloat(rewardInput.minDonation) || 0,
            description: rewardInput.description.trim(),
            limit: parseInt(rewardInput.limit) || null,
            claimed: 0,
          },
        ],
      });
      setRewardInput({ minDonation: "", description: "", limit: "" });
    }
  };

  const handleRemoveReward = (index) => {
    onChange({
      ...data,
      rewards: (data?.rewards || []).filter((_, i) => i !== index),
    });
  };

  const progress = data?.goalAmount
    ? Math.min(100, ((data?.raisedAmount || 0) / data.goalAmount) * 100)
    : 0;

  return (
    <div className="editorial_form crowdfunding_form">
      <div className="editorial_form_section">
        <label>
          Título da Campanha <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Ajude o João a fazer sua cirurgia"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>
            Categoria <span className="required">*</span>
          </label>
          <select
            value={data?.category || ""}
            onChange={(e) => onChange({ ...data, category: e.target.value })}
          >
            <option value="">Selecione</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Beneficiário</label>
          <input
            type="text"
            placeholder="Nome de quem receberá"
            value={data?.beneficiary || ""}
            onChange={(e) => onChange({ ...data, beneficiary: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          História da Campanha <span className="required">*</span>
        </label>
        <textarea
          placeholder="Conte sua história em detalhes. Por que você precisa de ajuda? Como o dinheiro será usado?"
          value={data?.story || ""}
          onChange={(e) => onChange({ ...data, story: e.target.value })}
          maxLength={5000}
          rows={6}
        />
        <span className="editorial_form_counter">
          {(data?.story || "").length}/5000
        </span>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>
            Meta (R$) <span className="required">*</span>
          </label>
          <input
            type="number"
            placeholder="10000"
            value={data?.goalAmount || ""}
            onChange={(e) =>
              onChange({ ...data, goalAmount: parseFloat(e.target.value) || 0 })
            }
            min="0"
            step="0.01"
          />
        </div>

        <div className="editorial_form_section">
          <label>Arrecadado (R$)</label>
          <input
            type="number"
            placeholder="0"
            value={data?.raisedAmount || ""}
            onChange={(e) =>
              onChange({ ...data, raisedAmount: parseFloat(e.target.value) || 0 })
            }
            min="0"
            step="0.01"
          />
        </div>

        <div className="editorial_form_section">
          <label>Data Final</label>
          <input
            type="date"
            value={data?.endDate?.split("T")[0] || ""}
            onChange={(e) =>
              onChange({ ...data, endDate: new Date(e.target.value).toISOString() })
            }
          />
        </div>
      </div>

      {data?.goalAmount > 0 && (
        <div className="editorial_form_section">
          <div
            style={{
              background: "var(--bg-third)",
              borderRadius: "8px",
              overflow: "hidden",
              marginTop: "8px",
            }}
          >
            <div
              style={{
                background: "var(--green-color)",
                height: "8px",
                width: `${progress}%`,
                transition: "width 0.3s ease",
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "4px",
              fontSize: "12px",
              color: "var(--color-secondary)",
            }}
          >
            <span>R$ {(data?.raisedAmount || 0).toLocaleString("pt-BR")}</span>
            <span>{progress.toFixed(0)}%</span>
            <span>R$ {(data?.goalAmount || 0).toLocaleString("pt-BR")}</span>
          </div>
        </div>
      )}

      <div className="editorial_form_section">
        <label>
          Recompensas (opcional)
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddReward}
          >
            + Adicionar
          </button>
        </label>
        <div className="editorial_form_row" style={{ marginBottom: "8px" }}>
          <input
            type="number"
            placeholder="A partir de R$"
            value={rewardInput.minDonation}
            onChange={(e) =>
              setRewardInput({ ...rewardInput, minDonation: e.target.value })
            }
            min="0"
            style={{ flex: 1 }}
          />
          <input
            type="text"
            placeholder="Descrição da recompensa"
            value={rewardInput.description}
            onChange={(e) =>
              setRewardInput({ ...rewardInput, description: e.target.value })
            }
            style={{ flex: 3 }}
          />
          <input
            type="number"
            placeholder="Limite"
            value={rewardInput.limit}
            onChange={(e) =>
              setRewardInput({ ...rewardInput, limit: e.target.value })
            }
            min="0"
            style={{ flex: 1 }}
          />
        </div>
        <div className="genre_chips">
          {(data?.rewards || []).map((reward, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveReward(i)}
              style={{ cursor: "pointer" }}
            >
              R${reward.minDonation}+: {reward.description}{" "}
              {reward.limit && `(${reward.limit} disp.)`} ×
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isVerified"
            checked={data?.isVerified || false}
            onChange={(e) => onChange({ ...data, isVerified: e.target.checked })}
          />
          <label htmlFor="isVerified">Campanha verificada</label>
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z" />
        </svg>
        <span>
          Campanhas com fotos e atualizações frequentes arrecadam 3x mais!
        </span>
      </div>
    </div>
  );
}
